import { http, HttpResponse } from "msw";

export const editorSchemaUrl = [
  http.get("*/api/schema_url", () =>
    HttpResponse.json(
      {
        schema_url: "",
      },
      { status: 200 }
    )
  ),
];
